import { useState } from "react";
import { Sample } from "@/comn/components/_";
import { Layout, Button, Pdf } from "@/comn/components";
import { useModal, useFetch } from "@/comn/hooks";
import "prismjs/themes/prism.css";
import { APIS } from "@/comn/sample/Sample/services/CgmeRpckItmAppService";

export const GuidePdf = () => {
    const modal = useModal();
    const [show, setShow] = useState(false);

    const fetch = {
        sampleRprt: useFetch({
            api: (rprtNo: string) => {
                return APIS.sampleRprt(rprtNo);
            },
        }),
        sampleRprtModal: useFetch({
            api: (rprtNo: string) => {
                return APIS.sampleRprt(rprtNo);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
        }),
    };

    return (
        <Sample title="PDF 뷰어" description="">
            <Sample.Section title="1. PDF뷰어 기본 기능">
                <Sample.Table
                    widths={["w-[15%]", "w-[15%]", "w-[15%]", "w-[30%]", "w-auto"]}
                    data={[
                        ["파라메터", "타입", "필수여부", "기본값", "비고"],
                        ["data", "arraybuffer", "Y", "", "pdf 파일 데이터"],
                        ["thumbnail", "boolean", "N", "false", "페이지 썸네일 표시 여부"],
                        ["download", "boolean", "N", "false", "다운로드 기능 표시 여부"],
                        ["print", "boolean", "N", "false", "프린트 기능 표시 여부"],
                        ["defaultPage", "number", "N", "1", "기본으로 보여줄 페이지 번호(1~)"],
                    ]}
                />
                <Sample.Code>{`import { Pdf } from "@/comn/components"; // Pdf 컴포넌트 import

// Service 파일 (Pdf Jasper 생성 Api 호출)
export const APIS = {
    sampleRprt: (rprtNo: string) => {
        return api.get(\`\${process.env.REACT_APP_API_SAMPLE}/api/v1/sample/sample-rprt/\${rprtNo}\`, {
            responseType: "arraybuffer",
        });
    },
};             

// 화면 파일( Service Api 호출 fetch)
const fetch = {
    sampleRprt: useFetch({
        api: (rprtNo: string) => {
            return APIS.sampleRprt(rprtNo);
        },        
    }),
};

// 화면 컴포넌트 return
return ...<Layout>
    // Pdf 출력 버튼
    <Button
        onClick={() => {
            fetch.sampleRprt.fetch("100182320-2023-1-000034");
        }}
    >
    View PDF
    </Button>

    // Pdf 출력 컴포넌트
    <Pdf data={fetch.sampleRprt.data} thumbnail={true} download={true} print={true} defaultPage={1} />
</Layout>...
`}</Sample.Code>
                <Layout direction="row">
                    <Layout.Right>
                        <Button
                            onClick={() => {
                                fetch.sampleRprt.fetch("100182320-2023-1-000034");
                            }}
                        >
                            View PDF
                        </Button>
                    </Layout.Right>
                </Layout>

                <Layout>
                    {/* <Pdf data={fetch.sampleRprt.data} thumbnail={true} download={true} print={true} defaultPage={1} /> */}
                </Layout>
            </Sample.Section>

            <Sample.Section
                title="2. PDF뷰어 모달"
                description={
                    <>
                        - PDF 뷰어를 모달창으로 표시하는 경우 modal에서 공통 모달 창 제공
                        <br />- modal.openModal( {'{ type : "pdf" , ... } '} )<br />
                    </>
                }
            >
                <Sample.Code>{`const fetch = {    
    sampleRprtModal: useFetch({
        api: (rprtNo: string) => {
            return APIS.sampleRprt(rprtNo);
        },
        onSuccess: (data) => {
            // API 조회 성공 후 모달창으로 Pdf 표시
            modal.openModal({
                type: "pdf",
                data: data,
                thumbnail: true,
                download: true,
                print: true,
            });
        },
    }),
};


<Button
    onClick={() => {
        fetch.sampleRprtModal.fetch("100182320-2023-1-000034");
    }}
>
    모달로 띄우기
</Button>    
    `}</Sample.Code>
                <Layout direction="row">
                    <Layout.Right>
                        <Button
                            onClick={() => {
                                fetch.sampleRprtModal.fetch("100182320-2023-1-000034");
                            }}
                        >
                            모달로 띄우기
                        </Button>
                    </Layout.Right>
                </Layout>
            </Sample.Section>
        </Sample>
    );
};
